
import { ApolloClient, InMemoryCache ,useQuery} from '@apollo/client';
import { BASE_URL } from '../static/constant';
import { message } from 'antd'
export default function getApolloClient(query, variables, mutation) {
  const token = GetToken()
  // console.log('token:' + token);
  if (token === null) {
    startLogin()
    return new Promise.reject()
  } else {
    if (mutation == null) {
      return Promise.race([request(query, variables), defineTimeout(10 * 1000)]).catch(err => {
        console.log('请求失败！' + err);
        if (err === "请求超时!") {
          message.error('Network timeout, please try again')
        } else {

          if (err.message.toString.indexOf("1000140")||err.message.toString.indexOf("1000139")) {
            //清除账户信息
            sessionStorage.clear()
            startLogin()
          } else if (err.message.toString() !== ''&&err.message.indexOf(",")) {
            var m = err.message.toString().split(',')
            message.error(m[2])
          } else {
            message.error(err)
          }
        }
      })
    } else {
      return Promise.race([up(mutation, variables), defineTimeout(10 * 1000)]).catch(err => {
        console.log('请求失败！' + err);
        console.log('请求失败message！' + err.message);
        if (err === "请求超时!") {
          message.error('Network timeout, please try again')
        } else {
          if (err.message.toString.indexOf("1000140")||err.message.toString.indexOf("1000139")) {
            //清除账户信息
            sessionStorage.clear()
            startLogin()
          } else if (err.message === '@@__1000141,password_error,password error') {
            //修改密码失败
            message.error('Please enter the correct old password！')
          } else if (err.message.toString() !== ''&&err.message.indexOf(",")) {
            var m = err.message.toString().split(',')
            message.error(m[2])
          } else {
            message.error(err)
          }
        }
      })
    }


  }
}
/**
 * 发送请求
 * @param {*} query 
 * @param {*} variables 
 * @returns 
 */
function request(query, variables) {
  return new Promise((resolve, reject) => {
    new ApolloClient({
      cache: new InMemoryCache(),
      uri: BASE_URL,
      headers: { authorization: GetToken() },
    }).query({
      query: query,
      variables: variables,
      notifyOnNetworkStatusChange: true,
      errorPolicy: 'all',
    }).then((res) => {
      console.log("then:", res)
      resolve(res)
    }).catch(e => {
      reject(e)
    });
  })
}
/**
 * 上传
 * @param {*} mutation 
 * @param {*} variables 
 * @returns 
 */
function up(mutation, variables) {
  return new Promise((resolve, reject) => {
    new ApolloClient({
      cache: new InMemoryCache(),
      uri: BASE_URL,
      headers: { authorization: GetToken() },
    }).mutate({
      mutation: mutation,
      variables: variables
    }).then((res) => {
      console.log("then:", res)
      resolve(res)
    }).catch(e => {
      reject(e)
    });
  })
}
/**
 * 
 * @returns 获取token
 */
function GetToken() {
  const token = sessionStorage.getItem("sessionToken")
  if (token === '') {
    return '';
  } else {
    return token;
  }
}


/**
 * 登陆过期
 */
function startLogin() {
  //跳转登陆页面
  window.location.href = '#/sign'
  window.location.reload()
  // 提示登录过期
  message.error('Your login status has expired, please log in again.')
}
/**
 * 超时
 * @param {超时时常} time 
 * @returns 
 */
function defineTimeout(time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject("请求超时!");
    }, time);
  });
}